export default __webpack_public_path__ + "static/English_Flag-17d4ca95087f050a50b2005cc7efd197.svg";